import { render } from "./TheMyCollectionCollectionDropdown.vue?vue&type=template&id=3cb07ed3&scoped=true&ts=true"
import script from "./TheMyCollectionCollectionDropdown.vue?vue&type=script&lang=ts"
export * from "./TheMyCollectionCollectionDropdown.vue?vue&type=script&lang=ts"

import "./TheMyCollectionCollectionDropdown.vue?vue&type=style&index=0&id=3cb07ed3&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb07ed3"]])

export default __exports__